module.exports = __webpack_public_path__ + "img/1f6f8.dc617d2.svg";